import { useNavigate } from "react-router-dom";
import Loader from "../Loader";
import State from "../Stats/State";

export default function Client({ observed, detail }) {
    const nav = useNavigate()
    if (!detail) return <Loader/>;

    return (
        <div className="p-10 bg-white rounded-lg shadow-md dark:bg-gray-800">
            {/* Header Section */}
            <div className="max-w-lg mb-12">
                <h3 className="text-2xl font-bold text-gray-800 dark:text-gray-200">Client</h3>
            </div>

            {/* Client Information Section */}
            <div className="flex flex-col items-center gap-10 md:flex-row">
                {/* Profile Image */}
                <div className={`rounded-full shadow-lg overflow-hidden ${observed === 'Proprietaire' && 'animate-fade-right animate-delay-700'}`}>
                    <img
                        alt={`Profil de ${detail.client.firstname}`}
                        src={detail.client.picture ? `${process.env.REACT_APP_API_PICTURE_URL}${detail.client.picture}` : "https://randomuser.me/api/portraits/men/86.jpg"}
                        className="object-cover w-52 h-52"
                    />
                </div>

                {/* Client Details */}
                <div className={`space-y-2 ${observed === 'Proprietaire' && 'animate-fade-left animate-delay-700'} items-center`}>
                    
                    <p className="text-2xl font-semibold text-gray-800 dark:text-gray-200">
                        {detail.client.firstname} {detail.client.lastname}
                    </p>

                    <div className={`col-span-12 lg:col-span-6 space-y-4 ${observed === 'Proprietaire' && 'animate-fade-down animate-delay-200'}`}>
                        <div className="flex items-center">
                            <span className="mr-5 text-xl font-medium text-gray-800 dark:text-gray-200">Téléphone:</span>
                            <span className="text-gray-600 dark:text-gray-200">{detail.client.phone}</span>
                        </div>

                        <div className="flex items-center">
                            <span className="mr-5 text-xl font-medium text-gray-800 dark:text-gray-200">Email:</span>
                            <span className="text-gray-600 dark:text-gray-200">{detail.client.email}</span>
                        </div>

                        <div className="flex items-center justify-start gap-4 mt-6">
                            <button
                            className="w-full px-6 py-2 text-white transition duration-150 bg-indigo-800 rounded-lg hover:bg-indigo-700 "
                            onClick={() => nav(`/message/${detail.client.email}/${detail.client.firstname} ${detail.client.lastname}`)}
                            >
                            Contacter
                            </button>
                        </div>
                    </div>
                </div>

                {detail.paiements && (
                <div className="mx-10">
                    <h3 className="mb-6 text-xl font-bold dark:text-gray-200">Rapports</h3>
                    <div className="grid grid-cols-2 gap-6 lg:grid-cols-2">
                        <div className={`grid-cols-1`}>
                            <State value={detail.paiements.count} name={'Paiements'} />
                        </div>

                        <div className={`grid-cols-1`}>
                            <State value={detail.reservationCount} name={'Réservation'} />
                        </div>
                    </div>
                </div>
                )}
            </div>

            {/* Contact and Information Section */}
                
        </div>

    )
}